import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // forms.* / colors.input* tokens (fallbacks = today's literals); mobile keeps
          // dev-mobile's 44 px height and 16 px text, desktop follows the tokens.
          `flex h-11 w-full rounded-[var(--pd-form-radius,var(--radius))] border-[length:var(--pd-form-border-width,1px)] bg-[var(--pd-color-input,hsl(var(--background)))] text-[color:var(--pd-color-input-foreground,inherit)] px-[var(--pd-form-padding-x,0.75rem)] py-[var(--pd-form-padding-y,0.5rem)] font-[family-name:var(--pd-font-form,inherit)] text-[length:var(--pd-form-size-mobile,1rem)] leading-6 md:h-[var(--pd-form-height,2.5rem)] md:text-[length:var(--pd-form-size,0.875rem)] md:leading-5
           ring-offset-background transition-colors
           file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground
           placeholder:text-[color:var(--pd-color-input-placeholder,hsl(var(--muted-foreground)))]
           focus-visible:outline-none focus-visible:ring-[length:var(--pd-form-focus-ring-width,2px)] focus-visible:ring-[color:var(--pd-form-focus-ring-color,hsl(var(--ring)))] focus-visible:ring-offset-[length:var(--pd-form-focus-ring-offset,2px)] focus-visible:border-[color:var(--pd-form-focus-border-color,hsl(var(--input)))]
           disabled:cursor-not-allowed disabled:opacity-[var(--pd-form-disabled-opacity,0.5)] disabled:bg-[var(--pd-form-disabled-background,hsl(var(--background)))] read-only:bg-[var(--pd-form-read-only-background,hsl(var(--background)))] aria-invalid:border-[color:var(--pd-form-error-border-color,hsl(var(--destructive)))]`,
          error
            ? 'border-destructive focus-visible:ring-destructive'
            : 'border-input',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
